import { useRef } from "react";
import { useFrame } from "@react-three/fiber";

export default function EnergyRings() {
  const ring1 = useRef();
  const ring2 = useRef();

  useFrame((state) => {
    const t = state.clock.elapsedTime;

    ring1.current.rotation.x = t * 0.25;
    ring1.current.rotation.y = t * 0.35;

    ring2.current.rotation.y = -t * 0.4;
    ring2.current.rotation.z = t * 0.2;
  });

  return (
    <>
      <mesh ref={ring1}>
        <torusGeometry args={[2.1, 0.02, 32, 200]} />
        <meshBasicMaterial color="#60a5fa" transparent opacity={0.5} />
      </mesh>

      <mesh ref={ring2}>
        <torusGeometry args={[2.7, 0.02, 32, 200]} />
        <meshBasicMaterial color="#22d3ee" transparent opacity={0.35} />
      </mesh>
    </>
  );
}
